import { object, string, boolean } from "yup";
import { stringExists } from "./helpers";

const COUNTRY_CODE = "$countryCode";

export default object().shape({
  credit_mid: boolean().when([COUNTRY_CODE, "debit_mid", "add_card_mid"], {
    is: (countryCode, debit_mid, add_card_mid) =>
      countryCode === "BRA" && !debit_mid && !add_card_mid,
    then: boolean().oneOf([true], "Must select one of the mid types")
  }),
  debit_mid: boolean().when(COUNTRY_CODE, {
    is: "BRA",
    then: boolean()
  }),
  add_card_mid: boolean().when(COUNTRY_CODE, {
    is: "BRA",
    then: boolean()
  }),
  credit_settlement_type: string().when(COUNTRY_CODE, {
    is: "BRA",
    then: stringExists
  })
});
